<template>
  <el-container v-loading="loading" id="top" style="height:969px;">
    <el-header>
      <HeaderView :userName="viewUserName" @calcHeaderSpace="calcHeaderSpace" />
    </el-header>
    <el-container>
      <el-container id="submenu" style="height:100%;overflow:auto;">
        <el-aside>
          <MenuView :cowMenuRadio="cow_menu_radio" :isAdmin="isAdmin" :userType="userType" :farmerId="farmer_id" />
        </el-aside>
      </el-container>
      <el-container id="sub" style="overflow: auto;">
        <el-main>
          <div>
            <el-row class="title-header">
              <span>レコーダー一覧を表示しています</span>
            </el-row>
          </div>
          <div v-if="nvr_rows.length != 0">
            <el-table v-if="nvr_check" stripe :data="nvr_rows" style="width:100%;min-width:560px;">
              <el-table-column label="" :width="headerWidth" />
              <el-table-column prop="name" label="レコーダー名" />
              <el-table-column label="レコーダー呼び出し">
                <template #default="scope">
                  <el-button color="#EEEEEC" class="recorder-btn-single" type="primary"
                    @click="jump_nvr_page(scope.$index)" :disabled="!scope.row.ipAddress">
                    呼び出し
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="" width="80px" style="border-left: 1px solid #EEEEEC;" />
              <el-table-column label="カメラ名">
                <template #default="scope">
                  <div v-if="scope.row.cameras.length <= 1">
                    <el-row v-for="(camera) in scope.row.cameras" :key="camera.id" class="recorder-label-single">
                      {{ camera.camera_name }}
                    </el-row>
                  </div>
                  <div v-if="scope.row.cameras.length > 1">
                    <el-row v-for="(camera) in scope.row.cameras" :key="camera.id" class="recorder-label">
                      {{ camera.camera_name }}
                    </el-row>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="カメラ再起動">
                <template #default="scope">
                  <el-row v-for="(camera) in scope.row.cameras" :key="camera.id"
                    style="justify-content:left;min-width:96px;">
                    <el-button v-if="scope.row.cameras.length <= 1" color="#EEEEEC" class="recorder-btn-single"
                      type="primary" size="small" @click="cameraReboot(camera.camera_id)" :disabled="isUserTypeDisabled">
                      再起動
                    </el-button>
                    <el-button v-if="scope.row.cameras.length > 1" color="#EEEEEC" class="recorder-btn" type="primary"
                      size="small" @click="cameraReboot(camera.camera_id)" :disabled="isUserTypeDisabled">
                      再起動
                    </el-button>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column label="フォーカスリセット">
                <template #default="scope">
                  <el-row v-for="(camera) in scope.row.cameras" :key="camera.id"
                    style="justify-content:left;min-width:140px;">
                    <el-button v-if="scope.row.cameras.length <= 1" color="#EEEEEC" class="recorder-btn" type="primary"
                      size="small" @click="focusReset(camera.camera_id)" :disabled="isUserTypeDisabled">
                      リセット
                    </el-button>
                    <el-button v-if="scope.row.cameras.length > 1" color="#EEEEEC" class="recorder-btn" type="primary"
                      size="small" @click="focusReset(camera.camera_id)" :disabled="isUserTypeDisabled">
                      リセット
                    </el-button>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="!loading & (nvr_rows.length == 0)">
            <el-row class="width100">
              <el-row class="width100" style="justify-content:center;margin-top:15%;">
                <p class="font_18 font_bold">登録されているレコーダーがありません</p>
              </el-row>
            </el-row>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import HeaderView from '../components/HeaderView';
import MenuView from '../components/MenuView';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getCurrentUser, signout } from "./js/cognito";
import AWSAPI from './js/aws-api';
import { ElMessage } from 'element-plus';
import rsa from 'js-crypto-rsa';
import keyutil from 'js-crypto-key-utils'
import aes from 'js-crypto-aes';
import ConstParam from './js/const';

// ロケール設定・タイムゾーン設定
dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

export default {
  name: 'LiveView',
  components: {
    HeaderView,
    MenuView
  },
  props: {},
  created() {
    this.$store.commit('setCowMenuSelect', 'ライブビュー');
  },
  mounted() {
    this.restore_param()
    this.checkUserType()
    this.generateKeys()
    this.get_current_user()
    this.hoverCssDelete()
  },
  beforeUnmount() {
    this.hoverCssInsert()
  },
  data() {
    return {
      isUserTypeDisabled: true,
      userTypeMessage: ConstParam.usertype_message,
      userType: ConstParam.disable_user_kind,
      headerWidth: "96px",
      saveStyle: [],
      // 暗号化
      apiRetry: false,
      decUsersRetry: false,
      publicKey_base64: null,
      privateKey_jwk: null,
      commonKey: null,
      commonKey_base64: null,
      commonKey_crypt: null,
      commonKey_time: 0,
      recs_enc: [],
      recs: [],
      cameras: [],
      // その他
      nvr_rows: [],
      nvr_answer: "",
      nvr_check: false,
      nvrData: {},
      nvrsData: {},
      barnsData: {},
      camerasData: [],
      camerasDataCount: 0,
      barnsInfoData: [],
      // ===== 以降固定 ====
      isAdmin: false,
      isVeterinarian: false,
      cow_menu_radio: "",
      column_number: 2, // 一覧カラム数
      loading: false,
      userData: {},
      farmer_id: "",
      viewUserName: "",
      viewFarmerName: "",
      logOut: false
      // ==================
    }
  },
  methods: {
    focusOut() {
      let obj = document.activeElement
      if (obj) {
        obj.blur()
      }
    },
    checkUserType() {
      this.isUserTypeDisabled = true
      if (this.userType != ConstParam.disable_user_kind) {
        this.isUserTypeDisabled = false
      }
    },
    cameraReboot(cam_id) {
      this.focusOut()
      this.set_camera_control(cam_id, false, true, "", "", "", "カメラ再起動");
    },
    focusReset(cam_id) {
      this.focusOut()
      this.set_camera_control(cam_id, false, "", "", true, "", "フォーカスリセット");
    },
    set_camera_control: async function (camera_id, get_settings, restart, continuous_af, af_request, zoom_level, message) {
      // カメラ制御
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.controlCamera(camera_id, get_settings, restart, continuous_af, af_request, zoom_level)
        .then((res) => {
          this.loading = false;
          if (this.checkAnswer(res, true)) {
            this.viewMessage(message + "を実行しました。", "success");
          }
        });
    },
    calcHeaderSpace(spacesize) {
      this.headerWidth = spacesize;
    },
    hoverCssDelete() {
      this.saveStyle = [];
      for (var si in document.styleSheets) {
        var styleSheet = document.styleSheets[si];
        if (!styleSheet.cssRules) continue;
        for (var ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.cssRules[ri].selectorText) continue;

          if (styleSheet.cssRules[ri].selectorText.match(':hover')) {
            if (styleSheet.cssRules[ri].selectorText.indexOf('.el-table') != -1) {
              let tempStyle = styleSheet.cssRules[ri];
              this.saveStyle.push(tempStyle['cssText']);
              styleSheet.deleteRule(ri);
            }
          }
        }
      }
    },
    hoverCssInsert() {
      for (let i = 0; i < this.saveStyle.length; i++) {
        document.styleSheets.item(0).insertRule(this.saveStyle[i]);
      }
    },
    aesDecryptRecs(encrypt_base64, iv_base64) {
      let encrypt_bin = Buffer.from(encrypt_base64, "base64")
      let iv_bin = Buffer.from(iv_base64, "base64")
      aes.decrypt(encrypt_bin, this.commonKey, { name: 'AES-CBC', iv: iv_bin })
        .then((decrypted) => {
          this.recs = JSON.parse(new TextDecoder().decode(decrypted))
        })
        .catch((err) => {
          console.log(err)
          this.recs = null
        })
    },
    decryptRecs() {
      // 復号
      if (this.commonKey_time == 0) {
        // commonKey更新待ち
        this.decRecsRetry = true
      } else if (this.commonKey_time == this.recs_enc.created_at) {
        // 復号可
        let enc_data_base64 = this.recs_enc.data
        let iv_base64 = this.recs_enc.iv
        this.aesDecryptRecs(enc_data_base64, iv_base64)
      } else if (this.commonKey_time < this.recs_enc.created_at) {
        // 共通鍵要更新
        this.decRecsRetry = true
        this.getCommonKey()
      } else {
        // 要データ再取得(古い共通鍵で暗号化されている場合)
        this.$emit('message', 'レコーダー一覧の取得に失敗しました。')
      }
    },
    generateKeys() {
      rsa.generateKey(2048).then((key) => {
        this.privateKey_jwk = key.privateKey;
        const keyObj = new keyutil.Key('jwk', key.publicKey);
        this.exportKey(keyObj);
      })
    },
    async exportKey(keyObj) {
      let der
      der = await keyObj.export('der')
      this.publicKey_base64 = Buffer.from(der).toString('base64')
      this.getCommonKey(this.publicKey_base64)
    },
    getCommonKey(pubKey) {
      AWSAPI.getCommonKey(pubKey)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.commonKey_base64 = res.data.data[0]['common_key'];
            this.commonKey_time = res.data.data[0]['created_at'];
            this.commonKey_crypt = Buffer.from(this.commonKey_base64, "base64");
            rsa.decrypt(
              this.commonKey_crypt,
              this.privateKey_jwk,
              'SHA-512'
            ).then((decrypted) => {
              this.commonKey = decrypted
            })
          }
        })
    },
    jump_nvr_page: function (id) {
      this.focusOut()
      if (!(this.nvr_rows[id].status && this.nvr_rows[id].ipAddress)) {
        this.viewMessage("このレコーダーは呼び出し出来ません。", "error");
        return;
      }
      let message = "レコーダー『" + this.nvr_rows[id].name + "』のWEBページを開きますか？";
      this.$confirm(message, "", {
        confirmButtonText: '開く',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        let tempUrl = encodeURI(this.nvr_rows[id].ipAddress);
        window.open(tempUrl, '_blank');
      }).catch(() => {
        return
      });
    },
    get_barns_data: async function () {
      this.loading = true;
      await AWSAPI.getBarns(this.userData['farmer']['farmer_id'])
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.barnsData = res['data']['data'];
          }
        });
    },
    get_cameras_data: async function (barnId) {
      this.loading = true;
      await AWSAPI.getCameras(barnId)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            let tempData = res['data']['data']
            for (let idx = 0; idx < tempData.length; idx++) {
              this.cameras.push(tempData[idx])
            }
            this.camerasDataCount++
          }
        });
    },
    get_recs_data: async function () {
      this.loading = true;
      await AWSAPI.getRecs(this.userData['farmer']['farmer_id'])
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.recs_enc = res['data']['encrypt'];
          }
        });
    },
    restore_param() {
      // パラメータ復元
      this.isAdmin = this.$store.state.userAdmin;
    },
    // ===== 以降固定 ====
    get_current_user: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getUserSp3()
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.userData = res['data']['data'][0];
          }
        });
    },
    get_id_token: async function () {
      try {
        const currentUser = await getCurrentUser();
        this.idToken = currentUser.idToken.jwtToken;
      } catch (e) {
        this.alertMessage("通知", ConstParam.relogin_message);
        this.$router.push('/login')
      }
    },
    viewMessage(message, status) {
      if (message === '') { return }
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status,
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    getAuthLevel(userData) {
      let ret = 0
      if ('user_type' in userData && userData.user_type) {
        ret = userData.user_type
      }
      return ret
    },
    getIsAdmin(authLevel) {
      let ret = true
      if (authLevel != 0) {
        ret = false
      }
      return ret
    }
    // ==================
  },
  watch: {
    userType: function () {
      this.checkUserType()
    },
    commonKey: function () {
      if (this.decRecsRetry) {
        this.decRecsRetry = false;
        this.decryptRecs();
      }
      if (this.decUsersRetry) {
        this.decUsersRetry = false;
        this.decryptUsers();
      }
    },
    recs_enc: function () {
      this.decryptRecs();
    },
    recs: function () {
      // NVR情報作成
      this.nvr_rows = [];
      for (let idx = 0; idx < this.recs.length; idx++) {
        let port_number = 80;
        if ("port_number" in this.recs[idx]) {
          port_number = this.recs[idx]['port_number']
        }
        let temp_ip = "http://" + this.recs[idx]['domain_name'].replace('http://', '') + ":" + port_number + "/";
        let tempCameras = [];
        for (let idy = 0; idy < this.cameras.length; idy++) {
          if (this.recs[idx].rec_id === this.cameras[idy].rec_id) {
            tempCameras.push(this.cameras[idy]);
          }
        }
        let tempNvr = {
          "name": this.recs[idx].rec_name,
          "username": this.recs[idx].username,
          "password": this.recs[idx].password,
          "ipAddress": temp_ip,
          "status": true,
          "check": "OK",
          "cameras": tempCameras
        }
        this.nvr_rows.push(tempNvr);
      }
      this.nvr_check = true;
      this.loading = false;
    },
    nvrsData: function () {
      // NVR情報作成
      this.nvr_rows = [];
      for (let idx = 0; idx < this.nvrsData.length; idx++) {
        let temp_ip = "";
        if ("ip_address" in this.nvrsData[idx]) {
          temp_ip = this.nvrsData[idx].ip_address;
        }
        let tempNvr = {
          "name": this.nvrsData[idx].nvr_name,
          "ipAddress": temp_ip,
          "status": true,
          "check": "OK"
        }
        this.nvr_rows.push(tempNvr);
      }
      this.nvr_check = true
      this.loading = false;
    },
    // ===== 以降固定 ====
    camerasDataCount: function () {
      if (this.camerasDataCount == this.barnsData.length) {
        // NVR情報取得
        this.get_recs_data();
      }
    },
    barnsData: function () {
      // get_user_sp2対応改修
      if ('farmer' in this.userData) {
        this.cameras = []
        this.camerasData = []
        this.userData.farmer.barns = structuredClone(this.barnsData);
        let tempBarns = structuredClone(this.userData.farmer.barns);
        for (let idx = 0; idx < tempBarns.length; idx++) {
          // if ('cameras' in tempBarns[idx]) {
          //   for (let idy = 0;idy < tempBarns[idx].cameras.length;idy++) {
          //     let tempCamId = "";
          //     let tempCamName = "";
          //     let tempRecId = "";
          //     if ('camera_id' in tempBarns[idx].cameras[idy]) {
          //       tempCamId = tempBarns[idx].cameras[idy].camera_id;
          //     }
          //     if ('camera_name' in tempBarns[idx].cameras[idy]) {
          //       tempCamName = tempBarns[idx].cameras[idy].camera_name;
          //     }
          //     if ('rec_id' in tempBarns[idx].cameras[idy]) {
          //       tempRecId = tempBarns[idx].cameras[idy].rec_id;
          //     }
          //     let tempData = {
          //       camera_id: tempCamId,
          //       camera_name: tempCamName,
          //       rec_id: tempRecId
          //     }
          //     this.cameras.push(tempData);
          //   }
          // }
          this.get_cameras_data(tempBarns[idx].barn_id)
        }
      }
    },
    userData: function () {
      if ('user_name' in this.userData) {
        this.viewUserName = this.userData['user_name'];
      }
      if ('farmer' in this.userData && 'farmer_name' in this.userData['farmer']) {
        this.viewFarmerName = this.userData['farmer']['farmer_name'];
      }
      if ('farmer' in this.userData && 'farmer_id' in this.userData['farmer']) {
        this.farmer_id = this.userData['farmer']['farmer_id'];
        this.get_barns_data() // get_user_sp2対応修正
      }
      let tempUserType = this.getAuthLevel(this.userData)
      this.isAdmin = this.getIsAdmin(tempUserType)
      this.userType = tempUserType
      // パラメータ保存(権限)
      this.$store.commit('setUserAdmin', this.isAdmin);
      // // NVR情報取得
      // this.get_recs_data();
      // // 牛房情報取得
      // this.get_barns_data();
      this.loading = false;
    }
    // ==================
  }
}
</script>

<style scoped>
/* .liveview-table .el-row, .event-table td, .event-table :deep(.el-table__cell) {
  padding: 0;
  border: none;
} */

:deep(td:nth-of-type(4)) {
  border-left: 1px solid #dadad8;
}

:deep(th:nth-of-type(4)) {
  border-left: 1px solid #dadad8;
}
</style>
